import React from 'react';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import PropTypes from 'prop-types';
import '../reset.css';
import styles from './index.css';

import Header from '../../components/header/';
import Navigation from '../../components/navigation/';
import SimpleSlider from './simpleSlider/';
import PicAndWordsSum from '../../components/picAndWordsSum/';
import Introduce from './introduce/';
import ActivityArea from './activityArea/';
import ProfileSlider from './profileSlider/';
import DynamicAndPlatform from './dynamicAndPlatform/';
import Coop from './coop/';
import Footer from '../../components/footer/';
import Contactus from '../../components/contactus/';
import BigTitByMoreOrAll from '../../components/bigTitByMoreOrAll/';

class Layout extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const {
            header,
            navigation,
            footer,
            slider,
            specialBanner,
            specialColumn,
            specialColumnF,
            receptionBanner,
            receptionRoom,
            receptionRoomF,
            activityNewsBanner,
            activityNews,
            activityNewsF,
            introduceBanner,
            introduce,
            activityBanner,
            activityPic,
            activityList,
            dynamicBanner,
            dynamic,
            dynamicF,
            platformBanner,
            platform,
            coopArr,
            contactus,
            committeeBanner,
            committeeData,
            committees,
            smallTitle: { zhuanlan, hjhkt, activities, jieshao, hdzq, weiyuan, dynamicTitle, platformTitle },
        } = content;

        const dynamicAndPlatform = {
            dynamic,
            platform,
            dynamicTitle,
            platformTitle,
        };

        const allActivityInfo = [];

        allActivityInfo.pic = content.activityPic;
        allActivityInfo.list = activityList;

        const dyAndPlatInfo = [];

        dyAndPlatInfo.dyBanner = content.dynamicBanner;
        dyAndPlatInfo.dyInfo = content.dynamicF;
        dyAndPlatInfo.platBanner = content.platformBanner;
        dyAndPlatInfo.paltInfo = content.platform;

        return (
            <div>
                <Chip id="10137" type="static" title="公用头部" groupName="财经研究院首页" content={header}>
                    <Header />
                </Chip>

                <Chip id="50112" type="struct" title="导航" groupName="公用导航" content={navigation}>
                    <Navigation current={0} />
                </Chip>
                <div className={styles.mainBox}>
                    <div className={styles.topPart}>
                        <div className={styles.leftContent}>
                            <div className={styles.sliderBox}>
                                <Chip
                                    id="75153"
                                    type="recommend"
                                    title="首页轮播图"
                                    groupName="财经研究院首页"
                                    content={slider}>
                                    <SimpleSlider />
                                </Chip>
                            </div>
                            <div className={styles.specialColumn}>
                                <Chip
                                    id="50117"
                                    type="struct"
                                    title="专栏banner"
                                    groupName="财经研究院首页"
                                    content={specialBanner}>
                                    <BigTitByMoreOrAll />
                                </Chip>

                                <PicAndWordsSum content={specialColumnF} />
                            </div>
                            <div className={styles.receptionRoom}>
                                <Chip
                                    id="50118"
                                    type="struct"
                                    title="会客厅banner"
                                    groupName="财经研究院首页"
                                    content={receptionBanner}>
                                    <BigTitByMoreOrAll />
                                </Chip>
                                <PicAndWordsSum content={receptionRoomF} />
                            </div>
                            <div className={styles.activityNews}>
                                <Chip
                                    id="50119"
                                    type="struct"
                                    title="活动资讯banner"
                                    groupName="财经研究院首页"
                                    content={activityNewsBanner}>
                                    <BigTitByMoreOrAll />
                                </Chip>
                                <PicAndWordsSum content={activityNewsF} />
                            </div>
                        </div>
                        <div className={styles.rightContent}>
                            <Chip
                                id="50113"
                                type="struct"
                                title="研究院介绍banner"
                                groupName="财经研究院首页"
                                content={introduceBanner}>
                                <BigTitByMoreOrAll />
                            </Chip>
                            <Introduce content={introduce} />
                            <Chip
                                id="50115"
                                type="struct"
                                title="活动专区banner"
                                groupName="财经研究院首页"
                                content={activityBanner}>
                                <BigTitByMoreOrAll />
                            </Chip>
                            <ActivityArea content={allActivityInfo} />
                        </div>
                    </div>
                    <div className={styles.midPart}>
                        <Chip
                            id="50120"
                            type="struct"
                            title="学术委员banner"
                            groupName="财经研究院首页"
                            content={committeeBanner}>
                            <BigTitByMoreOrAll />
                        </Chip>
                        <Chip
                            id="50121"
                            type="struct"
                            title="学术委员"
                            groupName="财经研究院首页"
                            content={committeeData}>
                            <ProfileSlider />
                        </Chip>

                        <DynamicAndPlatform content={dyAndPlatInfo} />
                        <Chip id="40048" type="static" title="合作媒体" groupName="财经研究院首页" content={coopArr}>
                            <Coop />
                        </Chip>
                        <Chip id="40049" type="static" title="联系我们" groupName="财经研究院首页" content={contactus}>
                            <Coop />
                        </Chip>
                    </div>
                </div>
                <Chip id="20036" type="struct" title="页尾" groupName="财经研究院首页" content={footer}>
                    <Footer />
                </Chip>

                <ChipEdit />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Layout.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Layout.defaultProps = {};

export default Layout;
